import { class_type } from "./.fable/fable-library.3.2.6/Reflection.js";
import { ofArray, map, isEmpty, collect } from "./.fable/fable-library.3.2.6/List.js";
import { Helpers_nothing } from "./.fable/Fable.React.7.4.1/Fable.React.Helpers.fs.js";
import { Props, Menu, SubMenuProps, SubMenu } from "./Interop/Antd/Menu.fs.js";
import * as react from "react";
import Navigation from "../src/Navigation.css";

export class Page {
    constructor(route, navComponent) {
        this.route = route;
        this.navComponent = navComponent;
    }
    get Routes() {
        const this$ = this;
        return this$.route;
    }
    get NavComponent() {
        const this$ = this;
        return this$.navComponent;
    }
}

export function Page$reflection() {
    return class_type("Loop54.Portal.WebUI.Navigation.Page", void 0, Page);
}

export function Page_$ctor_Z3796A576(route, navComponent) {
    return new Page(route, navComponent);
}

export class PageWithoutNavComponent {
    constructor(route) {
        this.route = route;
    }
    get Routes() {
        const this$ = this;
        return this$.route;
    }
    get NavComponent() {
        return null;
    }
}

export function PageWithoutNavComponent$reflection() {
    return class_type("Loop54.Portal.WebUI.Navigation.PageWithoutNavComponent", void 0, PageWithoutNavComponent);
}

export function PageWithoutNavComponent_$ctor_6E3A73D(route) {
    return new PageWithoutNavComponent(route);
}

export class PageGroup {
    constructor(key, name, icon, pages) {
        this.key = key;
        this.name = name;
        this.icon = icon;
        this.pages = pages;
    }
    get Routes() {
        const this$ = this;
        return collect((page) => page.Routes, this$.pages);
    }
    get NavComponent() {
        const this$ = this;
        const matchValue = this$.pages;
        if (isEmpty(matchValue)) {
            return Helpers_nothing;
        }
        else {
            const elems = map((page) => page.NavComponent, matchValue);
            return SubMenu(ofArray([new SubMenuProps(0, react.createElement(react.Fragment, {}, this$.icon, react.createElement("span", {}, this$.name))), new SubMenuProps(1, this$.key)]), elems);
        }
    }
}

export function PageGroup$reflection() {
    return class_type("Loop54.Portal.WebUI.Navigation.PageGroup", void 0, PageGroup);
}

export function PageGroup_$ctor_Z1FC11016(key, name, icon, pages) {
    return new PageGroup(key, name, icon, pages);
}

export function createRootNavComponent(pages, defaultOpenKeys, defaultSelectedKeys) {
    return Menu(ofArray([new Props(0, "inline"), new Props(3, Navigation.menu), new Props(1, defaultOpenKeys), new Props(2, defaultSelectedKeys)]), map((page) => page.NavComponent, pages));
}

